export const LOADING_DATA = "LOADING_DATA";
export const RESOURCES = "RESOURCES";
export const SET_TOTAL_RESOURCES = "SET_TOTAL_RESOURCES";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_DEPOSITS_LIST = "SET_DEPOSITS_LIST";
export const SET_DEPOSIT_DATA = "SET_DEPOSIT_DATA";
export const FILTER_INITIAL_DATE = "FILTER_INITIAL_DATE";
export const FILTER_FINAL_DATE = "FILTER_FINAL_DATE";
export const FILTER_STATUS = "FILTER_STATUS";
export const FILTER_ORDER = "FILTER_ORDER";
export const CURRENT_PAGE = "CURRENT_PAGE";
export const LIMIT = "LIMIT";
export const PAGE = "PAGE";
export const ORDINATION = "ORDINATION";
export const SUBTOTAL = "SUBTOTAL";
export const TOTAL_RESOURCES = "TOTAL_RESOURCES";
export const FILTER_PARAMS = "FILTER_PARAMS";
export const SHOW_FILTERS = "SHOW_FILTERS";
export const SET_FILTER_INITIAL_DATE = "SET_FILTER_INITIAL_DATE";
export const SET_FILTER_FINAL_DATE = "SET_FILTER_FINAL_DATE";
export const SET_FILTER_DEPOSIT_INITIAL_DATE = "SET_FILTER_DEPOSIT_INITIAL_DATE";
export const SET_FILTER_DEPOSIT_FINAL_DATE = "SET_FILTER_DEPOSIT_FINAL_DATE";
export const SET_FILTER_CARD_BRAND = "SET_FILTER_CARD_BRAND";
export const SET_FILTER_OPERATION = "SET_FILTER_OPERATION";
export const SET_FILTER_ORDINATION = "SET_FILTER_ORDINATION";
export const FILTER_VISIBLE = "FILTER_VISIBLE";
export const SET_FILTER_STATUS = "SET_FILTER_STATUS";
export const SET_FILTER_PARTNER = "SET_FILTER_PARTNER";
export const ERRORS = "ERRORS";
export const SHOW_ERROR = "SHOW_ERROR";
